import Image from 'next/image';
import type { ReactElement } from 'react';

type JaaqLogoProps = { className?: string };

export const JaaqLogo = ({ className }: JaaqLogoProps): ReactElement => (
  <div className={`inline-flex items-end gap-3 shrink-0 ${className ?? ''}`}>
    <Image src="/jaaq-logo.svg" alt="JAAQ" width={170} height={50} priority />
    <span className="text-fg-inverse text-sm font-normal leading-5 pb-px">Hub</span>
  </div>
);
